/* eslint-disable max-lines-per-function */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    StashboardProvider: ()=>StashboardProvider,
    useStashboard: ()=>useStashboard
});
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _dayjs = /*#__PURE__*/ _interopRequireDefault(require("dayjs"));
const _relativeTime = /*#__PURE__*/ _interopRequireDefault(require("dayjs/plugin/relativeTime"));
const _ = require("..");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
_dayjs.default.extend(_relativeTime.default);
const StashboardContext = /*#__PURE__*/ _react.default.createContext({});
const StashboardProvider = ({ children  })=>{
    const { setMember , setWalletId , setMerchantId , stashboardKeys , stashboards , setStashboardKeys , setStashboards  } = (0, _.useSpringBigStore)();
    const { fetch , isLoading , handleDate  } = (0, _.useStashboards)();
    const handleNewStashboard = (0, _react.useCallback)(async (stashboardMsg)=>{
        const { stashboard_key , member_key , merchant_id  } = stashboardMsg;
        const stashboard = await (0, _.getStashboardData)({
            stashboard_key,
            type: window.location ? 'sms' : 'push'
        });
        stashboard._key = stashboard_key;
        const member = await (0, _.getMember)({
            walletId: member_key
        });
        const alreadyFetched = stashboards?.map((s)=>s._key);
        const oldKeys = stashboardKeys?.filter((k)=>alreadyFetched?.includes(k.stashboard_key));
        const validStashboardKeys = oldKeys?.filter((key)=>!!handleDate(key.epoch));
        const cleanOldStashboards = stashboards?.filter((s)=>validStashboardKeys?.map((k)=>k.stashboard_key).includes(s._key));
        setStashboards([
            ...cleanOldStashboards || [],
            stashboard
        ]);
        await setWalletId(member_key);
        await setMerchantId(merchant_id);
        setMember(member);
        await new Promise((res)=>setTimeout(res, 1000));
        setStashboardKeys([
            ...stashboardKeys || [],
            stashboardMsg
        ]);
        _.observer.emit('stashboard-received', {
            stashboard
        });
    }, [
        setStashboards,
        stashboardKeys
    ]);
    const receivePnMessage = (0, _react.useCallback)((msg)=>{
        const { remoteMessage  } = msg;
        if (!remoteMessage.data) {
            return;
        }
        const msgData = remoteMessage.data;
        if (!msgData.keys_json) {
            return;
        }
        const stashboardMsg = JSON.parse(msgData.keys_json);
        if (!stashboardMsg.member_key || !stashboardMsg.stashboard_key || !stashboardMsg.merchant_id) {
            return;
        }
        handleNewStashboard(stashboardMsg);
    }, [
        handleNewStashboard
    ]);
    (0, _.useOnAppEvent)('firebase-push-notification', receivePnMessage, [
        receivePnMessage
    ]);
    (0, _react.useEffect)(()=>{
        fetch();
    }, []);
    return /*#__PURE__*/ _react.default.createElement(StashboardContext.Provider, {
        value: {
            stashboards: stashboards || [],
            setStashboards,
            stashboardKeys: stashboardKeys || [],
            setStashboardKeys,
            isLoading
        }
    }, children);
};
const useStashboard = ()=>_react.default.useContext(StashboardContext);
